import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Modal, { ModalBackground } from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import EmployeesContextProvider from '../employees/EmployeesContextProvider';
import EmployeesList from '../employees/EmployeesList';

export default function DashboardEmployeesSelectorModal(props: {
	selection: graphql.User[];
	onChange: (group: graphql.User[]) => void;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={props.onDismiss}>
					<ModalHeaderTitle>
						{t('dashboard.sidebar.filters.employees.modal.title')}
					</ModalHeaderTitle>
				</ModalHeader>
				<Box height="100vh" maxHeight="calc(100vh - 120px - 68px)" overflow="scroll">
					<EmployeesContextProvider>
						<EmployeesList
							linked={false}
							selection={props.selection}
							onChange={props.onChange}
							columns={['firstName', 'lastName']}
						/>
					</EmployeesContextProvider>
				</Box>
			</Modal>
		</ModalBackground>
	);
}
